import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import {
  documentRequestsApi,
  type CreateDocumentRequestDto,
} from '@/api/document-requests';

/**
 * Get documents for a specific client
 */
export function useClientDocuments(clientId: number | undefined, archive: 0 | 1 = 0) {
  return useQuery({
    queryKey: ['document-requests', 'client', clientId, archive],
    queryFn: () => documentRequestsApi.getByClient(clientId!, archive),
    enabled: !!clientId,
    staleTime: 30_000,
  });
}

/**
 * Create document request mutation
 */
export function useCreateDocument() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (dto: CreateDocumentRequestDto) => documentRequestsApi.create(dto),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['document-requests', 'client', variables.clientId],
      });
      toast.success('Заявка создана');
    },
    onError: (error) => {
      const message =
        error instanceof Error ? error.message : 'Ошибка создания заявки';
      toast.error('Ошибка', { description: message });
    },
  });
}
